import "../../assets/fonts/fonts.css";
import styles from "./header.module.css";
import React, {useRef, useEffect, useState} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import Routes from "../../assets/Routes/Routes";
import cn from "classnames";
import texts from "../../assets/ContextProvider/textsLocalized.json";
import {ReactComponent as HeaderLogo} from "./img/cinemAI-logo.svg";
import text from "../../assets/ContextProvider/textsLocalized.json";


const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const headerRef = useRef(null);
  const navRef = useRef(null);
  const counterRef = useRef(null);
  const backButtonRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  const [isDisplayWidth, setIsDisplayWidth] = useState(false);


  useEffect(() => {
    const body = document.body;

    if (isOpen) {
      body.classList.add(styles["non-scroll"]);
      const usedAttemptsDaily = localStorage.getItem("generatedAttemptsDaily");
      counterRef.current.textContent = usedAttemptsDaily ?? "0";
    } else {
      body.classList.remove(styles["non-scroll"]);
    }

    return () => {
      body.classList.remove(styles["non-scroll"]);
    };
  }, [isOpen]);


  useEffect(() => {
    if (
      pathName === Routes.login ||
      pathName.includes('/shared/')) {
      headerRef.current.classList.add(styles.hide);
    } else {
      headerRef.current.classList.remove(styles.hide);
    }
    if (isOpen) {
      backButtonRef.current.classList.add(styles.backButtonHidden);
    } else {
      backButtonRef.current.classList.remove(styles.backButtonHidden);
    }
  }, [pathName, isOpen]);


  const menuBtn = cn(styles.menuBtn, {
    [styles.menuBtnActive]: isOpen,
  });


  const menuNav = cn(styles.menuNav, {
    [styles.menuNavActive]: isOpen,
  });


  const headerHeight = () => {
    return headerRef.current.offsetHeight;
  };


  const handleMenuVisibility = () => {
    setIsOpen(!isOpen);
    navRef.current.style.top = headerHeight() + 1 + "px";
  };


  const menuRedirect = ({target}) => {
    const link = target.closest('[data-href]')?.dataset.href;

    if (link) {
      setIsOpen(false);
      navigate(link);
    }
  };


  const navigatePreviousPage = () => {
    setIsOpen(false);
    navigate(-1);
  };


  const handleHomeNavigate = () => {
    setIsOpen(false);
    navigate(Routes.welcome);
  };


  useEffect(() => {
    if (pathName === Routes.terms && window.innerWidth > 500) {
      setIsDisplayWidth(true);
    } else {
      setIsDisplayWidth(false);
    }
  }, [pathName])


  return (
    <header ref={headerRef}
            className={`${styles.headerWrapper}
            ${isDisplayWidth ? styles['display-width'] : ""}`}>
      <div className={styles.header}>
        <div ref={backButtonRef} className={styles.btnBack}>
          <button className={styles.buttonBack} onClick={navigatePreviousPage}></button>
        </div>
        <div className={styles.logoWrapper}>
          <HeaderLogo className={styles.logo}
                      onClick={handleHomeNavigate}
                      width={145}
                      height={32}/>
        </div>
        <div onClick={handleMenuVisibility} className={menuBtn}>
          <span></span>
        </div>

        <nav onClick={menuRedirect} ref={navRef} className={menuNav}>
          <div className={styles.menuBlock}>
            <h2 className={styles.menuTitle}>{texts.header["title"]}</h2>
            <button data-href={Routes.welcome} className={styles.menuItem}>
                <span data-href={Routes.welcome} className={styles.menuItemIcon}>
                  <img src={require("./img/home.png")} alt="icon home"/>
                </span>
              <span data-href={Routes.welcome}>{texts.header['welcome']}</span>
            </button>

            <button data-href={Routes.favorites} className={styles.menuItem}>
                <span data-href={Routes.favorites} className={styles.menuItemIcon}>
                  <img src={require("./img/favourites.png")} alt="icon home"/>
                </span>
              <span data-href={Routes.favorites}>{texts.header['favorites']}</span>
            </button>

            <button data-href={Routes.movieNews} className={styles.menuItem}>
                <span data-href={Routes.movieNews} className={styles.menuItemIcon}>
                  <img src={require("./img/news.png")} alt="icon news"/>
                </span>
              <span data-href={Routes.movieNews}>{texts.header['news']}</span>
            </button>

            <button data-href={Routes.terms} className={styles.menuItem}>
                <span data-href={Routes.terms} className={styles.menuItemIcon}>
                  <img src={require("./img/terms.png")} alt="icon home"/>
                </span>
              <span data-href={Routes.terms}>{texts.header['terms']}</span>
            </button>

            {/* <button data-href={Routes.contact} className={styles.menuItem}>
                <span data-href={Routes.contact} className={styles.menuItemIcon}>
                  <img src={require("./img/contact.png")} alt="icon home"/>
                </span>
              <span data-href={Routes.contact}>{texts.header['contact']}</span>
            </button> */}

            <div className={styles.attemptsCounter}>
              {texts.header['attempts']}
              <span>
              <strong ref={counterRef}>0</strong>
              <strong>/5</strong>
              </span>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
